import * as React from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Button,
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

import { useWorkspaceContext } from "../context";



export default function WorkspaceModeSelector() {
    const [isOpen, setOpen] = React.useState(false);
    const workspaceContext = useWorkspaceContext();
    // console.log("Workspace data", workspaceContext.data);
    return (
        <Dropdown
            isOpen={isOpen}
            toggle={() => setOpen(st => !st)}
            direction="down"
        >
            <DropdownToggle caret>
                <FontAwesomeIcon icon={faTh} />{" "}
                <span
                    style={{
                        // minWidth: 100,
                        // maxWidth: 200,
                        width: 150,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        margin: "inherit",
                        lineHeight: "1.3em",
                        height: "1em",
                    }}
                    className="text-start m-0 p-0"
                >
                    {workspaceContext.data?.metadata?.displayName
                    || <span className="text-muted">Untitled workspace</span>}
                    {" "}
                </span>
            </DropdownToggle>
            <DropdownMenu style={{ minWidth: 250 }}>
                <DropdownItem>Workspace settings</DropdownItem>
                {false && <DropdownItem text>
                    <div style={{minWidth: 300, textAlign: "center"}}>
                        <Button className="me-1" style={{width: 80}}>One</Button>
                        <Button className="me-1" style={{width: 80}}>Two</Button>
                        <Button className="me-1" style={{width: 80}}>Three</Button>
                    </div>
                </DropdownItem>}
                <DropdownItem divider />
                <DropdownItem tag={Link} to="/workspaces">
                    All workspaces
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
}
